import { NoxusInputField } from "../InputField";
import { Control, FieldErrors } from "react-hook-form";
import { FormEventHandler } from "react";
import { NoxusIconPickerField } from "@/components/Flows/NoxusIconPicker";
import {
  MAX_ENTITY_NAME,
  MAX_ENTITY_DESCRIPTION,
} from "@/constants/entityLimits";

export interface IWorkflowEditFormData {
  title: string;
  description: string;
  icon: string;
}

export const WorkflowEditForm = ({
  forcedName,
  isEditable = true,
  control,
  errors,
  onSubmit,
}: {
  forcedName?: string;
  isEditable?: boolean;
  control: Control<any>;
  errors: FieldErrors<any>;
  onSubmit: FormEventHandler<HTMLFormElement>;
}) => {
  return (
    <form className="w-full" id="flow-edit-form" onSubmit={onSubmit}>
      <div className="flex flex-col gap-6 items-start w-full">
        <NoxusIconPickerField
          name="icon"
          label="Icon"
          control={control}
          size="md"
          disable={!isEditable}
        />
        <NoxusInputField
          name="title"
          maxLength={MAX_ENTITY_NAME}
          label="Title"
          errors={errors}
          forcedName={forcedName || "Untitled"}
          disable={!isEditable}
          control={control}
          rules={{
            required: { value: true, message: "" },
          }}
          autoFocus
        />
        <NoxusInputField
          name="description"
          label="Description"
          maxLength={MAX_ENTITY_DESCRIPTION}
          isTextarea
          isResizable={false}
          helperText="Doesn’t affect the flow's behavior but helps other tools interpret it more accurately."
          disable={!isEditable}
          errors={errors}
          control={control}
        />
      </div>
    </form>
  );
};
